export default __webpack_public_path__ + "static/media/1875.e5f80991.png";